import request from "@/api";

export function listScore(data) {
    return request({
        url: '/api/score/getScoreList',
        method: 'get',
        params: data
    })
}
export function saveScore(data) {
    return request({
        url: '/api/score/saveScore',
        method: 'post',
        data: data
    })
}

export function getScoreInfo(data) {
    return request({
        url: '/api/score/getScoreInfo',
        method: 'get',
        params: data
    })
}

export function deleteScore(data) {
    return request({
        url: '/api/score/deleteScore',
        method: 'post',
        data: data
    })
}

export function listScoreSubjectReport(data) {
    return request({
        url: '/api/scoreSubject/getScoreSubjectReportList',
        method: 'get',
        params: data
    })
}

export function listScoreSubjectRank(data) {
    return request({
        url: '/api/scoreSubject/getScoreSubjectRankList',
        method: 'get',
        params: data
    })
}

export function listScoreSubjectAnalysis(data) {
    return request({
        url: '/api/scoreSubject/getScoreSubjectAnalysisList',
        method: 'get',
        params: data
    })
}

export function listScoreSubjectCompare(data) {
    return request({
        url: '/api/scoreSubject/getScoreSubjectCompareList',
        method: 'get',
        params: data
    })
}




